import { SVGProps } from 'react'

export const ChangemakerProfile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='256'
    height='180'
    viewBox='0 0 256 180'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect
      x='24.5'
      y='13.0002'
      width='206.454'
      height='154.595'
      rx='3.4321'
      fill='#B2CAE0'
      stroke='#003263'
    />
    <g filter='url(#filter0_d_93_1725)'>
      <rect
        x='39.8293'
        y='39.2527'
        width='170.765'
        height='28.0864'
        rx='2.80864'
        fill='white'
      />
      <rect
        x='40.6912'
        y='40.1146'
        width='169.042'
        height='26.3626'
        rx='1.94675'
        stroke='white'
        strokeWidth='1.72379'
      />
    </g>
    <rect
      x='39.8293'
      y='73.7194'
      width='170.765'
      height='28.0864'
      rx='2.80864'
      fill='#E8F0F6'
    />
    <rect
      x='39.8293'
      y='108.185'
      width='170.765'
      height='28.0864'
      rx='2.80864'
      fill='#E8F0F6'
    />
    <circle cx='57.3738' cy='87.1816' r='9.56969' fill='#B2CAE0' />
    <path
      d='M57.3734 84.1283C57.8984 84.1283 58.3239 84.5567 58.3239 85.0853C58.3239 85.6139 57.8984 86.0423 57.3734 86.0423C56.8483 86.0423 56.4229 85.6139 56.4229 85.0853C56.4229 84.5567 56.8483 84.1283 57.3734 84.1283ZM57.3734 88.2296C58.7177 88.2296 60.1344 88.895 60.1344 89.1866V89.6879H54.6124V89.1866C54.6124 88.895 56.0291 88.2296 57.3734 88.2296ZM57.3734 83.2625C56.3731 83.2625 55.5629 84.0782 55.5629 85.0853C55.5629 86.0924 56.3731 86.9081 57.3734 86.9081C58.3737 86.9081 59.1839 86.0924 59.1839 85.0853C59.1839 84.0782 58.3737 83.2625 57.3734 83.2625ZM57.3734 87.3638C56.1649 87.3638 53.7524 87.9744 53.7524 89.1866V90.5537H60.9943V89.1866C60.9943 87.9744 58.5819 87.3638 57.3734 87.3638Z'
      fill='white'
    />
    <circle cx='56.5697' cy='53.0696' r='9.56969' fill='#B2CAE0' />
    <path
      d='M56.5693 50.0164C57.0943 50.0164 57.5198 50.4448 57.5198 50.9734C57.5198 51.502 57.0943 51.9303 56.5693 51.9303C56.0442 51.9303 55.6188 51.502 55.6188 50.9734C55.6188 50.4448 56.0442 50.0164 56.5693 50.0164ZM56.5693 54.1177C57.9135 54.1177 59.3302 54.783 59.3302 55.0747V55.5759H53.8083V55.0747C53.8083 54.783 55.225 54.1177 56.5693 54.1177ZM56.5693 49.1506C55.569 49.1506 54.7588 49.9663 54.7588 50.9734C54.7588 51.9805 55.569 52.7962 56.5693 52.7962C57.5696 52.7962 58.3797 51.9805 58.3797 50.9734C58.3797 49.9663 57.5696 49.1506 56.5693 49.1506ZM56.5693 53.2519C55.3608 53.2519 52.9483 53.8625 52.9483 55.0747V56.4418H60.1902V55.0747C60.1902 53.8625 57.7778 53.2519 56.5693 53.2519Z'
      fill='white'
    />
    <circle cx='57.3738' cy='122.27' r='9.56969' fill='#B2CAE0' />
    <path
      d='M57.3734 119.216C57.8984 119.216 58.3239 119.645 58.3239 120.173C58.3239 120.702 57.8984 121.13 57.3734 121.13C56.8483 121.13 56.4229 120.702 56.4229 120.173C56.4229 119.645 56.8483 119.216 57.3734 119.216ZM57.3734 123.318C58.7177 123.318 60.1344 123.983 60.1344 124.275V124.776H54.6124V124.275C54.6124 123.983 56.0291 123.318 57.3734 123.318ZM57.3734 118.351C56.3731 118.351 55.5629 119.166 55.5629 120.173C55.5629 121.18 56.3731 121.996 57.3734 121.996C58.3737 121.996 59.1839 121.18 59.1839 120.173C59.1839 119.166 58.3737 118.351 57.3734 118.351ZM57.3734 122.452C56.1649 122.452 53.7524 123.063 53.7524 124.275V125.642H60.9943V124.275C60.9943 123.063 58.5819 122.452 57.3734 122.452Z'
      fill='white'
    />
    <rect
      x='40.5'
      y='39.9999'
      width='170'
      height='27'
      rx='3.4321'
      stroke='#003263'
      strokeDasharray='4.78 4.78'
    />
    <defs>
      <filter
        id='filter0_d_93_1725'
        x='36.459'
        y='37.0058'
        width='179.753'
        height='37.0741'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='1.12346' dy='2.24691' />
        <feGaussianBlur stdDeviation='2.24691' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0.195 0 0 0 0 0.39 0 0 0 0.07 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_93_1725'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_93_1725'
          result='shape'
        />
      </filter>
    </defs>
  </svg>
)
